export default (url: string) => (window.location.href = url)
